import { render, staticRenderFns } from "./Areas_Edit.vue?vue&type=template&id=04aa2432&scoped=true&"
import script from "./Areas_Edit.vue?vue&type=script&lang=js&"
export * from "./Areas_Edit.vue?vue&type=script&lang=js&"
import style0 from "./Areas_Edit.vue?vue&type=style&index=0&id=04aa2432&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04aa2432",
  null
  
)

export default component.exports